<template>
  <div class="app-main-content finance-interface">
    <div class="tabs-container">
      <span style="position: absolute; right: 10px; margin-top: 5px;z-index: 999">
        <el-link :type="lbAccountType" @click="selectAccountSetHandler">{{ lbAccount }}</el-link>
      </span>
      <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
        <el-tab-pane v-if="accountSet !== null && $checkPermission(['tab_FinancialExchangeRateList'])" :label="$t('CargoMsg.Cargo_GroupExchangeRate')" name="financialExchangeRate">
          <!-- 对应 cargoware的 FinancialExchangeRateList -->
          <financial-exchange-rate-list :account-sets="accountSets" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_SobSetup')" name="accountSet">
          <!-- 对应 cargoware的 Ledger -->
          <ledger :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane v-if="accountSet !== null && $checkPermission(['tab_VoucherGroupingRule'])" :lazy="true" :label="$t('CargoMsg.Cargo_VoucherGroupingRule')" name="accountingDocumentsRule">
          <!-- 对应 cargoware的 VoucherGrouppingRule -->
          <voucher-groupping-rule :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane v-if="accountSet !== null && $checkPermission(['tab_EntryGroupingRule'])" :lazy="true" :label="$t('CargoMsg.Cargo_GroupingRulesOfJournalEntries')" name="accountingEntryRule">
          <!-- 对应 cargoware的 EntryGrouppingRule -->
          <entry-groupping-rule :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane v-if="accountSet !== null && $checkPermission(['tab_EntrySummaryMapping'])" :lazy="true" :label="$t('CargoMsg.Cargo_AbstractRuleOfJournalEntry')" name="entrySummaryRule">
          <!-- 对应 cargoware的 EntrySummaryMapping -->
          <entry-summary-mapping :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane v-if="accountSet !== null && $checkPermission(['tab_VoucherTypeMapping'])" :lazy="true" :label="$t('CargoMsg.Cargo_VoucherLetter')" name="accountingDocumentType">
          <!-- 对应 cargoware的 VoucherTypeMapping -->
          <voucher-type-mapping :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane v-if="accountSet !== null && $checkPermission(['tab_EncodeMapping'])" :lazy="true" :label="$t('CargoMsg.Cargo_CodingMapping')" name="financeCodeMapping">
          <!-- 对应 cargoware的 EncodeMapping -->
          <encode-mapping :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane v-if="accountSet !== null && $checkPermission(['tab_TitleMapping'])" :lazy="true" :label="$t('CargoMsg.Cargo_AccountTitleMapping')" name="entryAccountTitle">
          <!-- 对应 cargoware的 TitleMapping -->
          <title-mapping :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane v-if="accountSet !== null && $checkPermission(['tab_AccountTitleList'])" :lazy="true" :label="$t('CargoMsg.Cargo_ConfigureAccountTitle')" name="accountTitle">
          <!-- 对应 cargoware的 AccountTitleList -->
          <account-title-list :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane v-if="accountSet !== null && accountSet.softwareVersions === 'WT' && $checkPermission(['tab_AccountTitleBalanceList'])" :lazy="true" :label="$t('CargoMsg.Cargo_InitialBalance')" name="accountTitleBalance">
          <!-- 对应 cargoware的 AccountTitleBalanceList -->
          <account-title-balance-list :account-set="accountSet" />
        </el-tab-pane>
        <el-tab-pane v-if="accountSet !== null && accountSet.softwareVersions === 'WT' && $checkPermission(['tab_FiscalPeriodList'])" :lazy="true" :label="$t('CargoMsg.Cargo_FinancialPeriod')" name="fiscalPeriod">
          <!-- 对应 cargoware的 FiscalPeriodList -->
          <fiscal-period-list :account-set="accountSet" :account-sets="accountSets" />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('CargoMsg.Cargo_VoucherLineNumberSetting')" name="voucherLineSetting">
          <!-- 对应 cargoware的 VoucherLineSetting -->
          <voucher-line-setting :account-set="accountSet" />
        </el-tab-pane>
      </el-tabs>

    </div>
    <!-- 选择账套 -->
    <account-set-popup
      ref="refAccountSetPopup"
      :visible.sync="accountSetPopup.visible"
      :mode="accountSetPopup.mode"
      @select="data=>accountSet=data"
      @cancel="()=>accountSetPopup.visible=false"
    />
  </div>
</template>

<script>
import FinancialExchangeRateList from '@/views/cargo/v0/FinanceManage/FinanceInterface/FinancialExchangeRateList'
import VoucherLineSetting from '@/views/cargo/v0/FinanceManage/FinanceInterface/VoucherLineSetting'
import Ledger from '@/views/cargo/v0/FinanceManage/FinanceInterface/Ledger'
import VoucherGrouppingRule from '@/views/cargo/v0/FinanceManage/FinanceInterface/VoucherGrouppingRule'
import EntryGrouppingRule from '@/views/cargo/v0/FinanceManage/FinanceInterface/EntryGrouppingRule'
import EntrySummaryMapping from '@/views/cargo/v0/FinanceManage/FinanceInterface/EntrySummaryMapping'
import VoucherTypeMapping from '@/views/cargo/v0/FinanceManage/FinanceInterface/VoucherTypeMapping'
import EncodeMapping from '@/views/cargo/v0/FinanceManage/FinanceInterface/EncodeMapping'
import TitleMapping from '@/views/cargo/v0/FinanceManage/FinanceInterface/TitleMapping'
import AccountTitleList from '@/views/cargo/v0/FinanceManage/FinanceInterface/AccountTitleList'
import AccountTitleBalanceList from '@/views/cargo/v0/FinanceManage/FinanceInterface/AccountTitleBalanceList/index'
import FiscalPeriodList from '@/views/cargo/v0/FinanceManage/FinanceInterface/FiscalPeriodList'
import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'

export default {
  name: 'FinanceInterface',
  components: { FinancialExchangeRateList, Ledger, VoucherGrouppingRule, EntryGrouppingRule, EntrySummaryMapping,
    VoucherTypeMapping, EncodeMapping, TitleMapping, AccountTitleList, AccountTitleBalanceList, FiscalPeriodList, AccountSetPopup, VoucherLineSetting },
  data() {
    return {
      activeTabName: 'financialExchangeRate',
      accountSet: null, // 当前账套
      accountSetPopup: { visible: false, mode: 'office' }
    }
  },
  computed: {
    lbAccount() {
      console.log('lbAccount', this.accountSet)
      return this.accountSet === null ? this.$t('CargoMsg.Cargo_PleaseSelectSob') : (this.$t('CargoMsg.Cargo_SetsOfBooksP') + this.accountSet.name)
    },
    lbAccountType() {
      return this.accountSet === null ? 'danger' : 'primary'
    },
    accountSets() {
      return this.$refs.refAccountSetPopup ? this.$refs.refAccountSetPopup.rowData : []
    }
  },
  watch: {
    accountSet(newVal) {
      console.log('accountSet变更：')
      console.log(newVal)
    }
  },
  async mounted() {
    const allowFinanceOperation = await BSWarningUtil.checkFinanceExpire(this.$route, this.$router)
    if (!allowFinanceOperation) {
      return
    }
    if (this.accountSet === null) {
      this.selectAccountSetHandler()
    }
  },
  methods: {
    // 选择账套
    selectAccountSetHandler() {
      this.accountSetPopup.visible = true
    }
  }
}
</script>

<style scoped>

</style>
